<template>
  <div id="app">
    <div class='container' style="min-height:70vh">
    <router-view v-if="this.loading==false && error=='' " />
    <div v-if="this.loading==true && error!='' " >
        Carregando...
    </div>
    <div class="row mt-5" v-if='error!=""' >
      <div class="col">
           <div class="alert alert-danger" v-html="error">
        </div>
    
      </div>
    </div>

    </div>
    <!-- <div class="row mt-5"> -->
      <div class="col-5 mt-5 mx-auto">
        <hr/>
          <h5><small><b>Sítio Alegria</b></small></h5>  WhatsApp 61 9938-8232 - Email: sitioalegria@gmail.com
      </div>
    <!-- </div> -->
  
  </div>
</template>


<script>
export default{

  data(){
    return {
      loading:true,
      error:''
    }
  },
  async created(){
    let res = await this.$store.dispatch('getProdutos')
    if(res==false){
      this.error = "Ocorreu um erro de conexão com o servidor. Tente recarregar a página novamente!"
    }
    let res2 = await this.$store.dispatch('getListInfo')
    let res3 = await this.$store.dispatch('getRegioes')
    this.loading = false;
 },

  computed:{
    
  }


}
</script>



<style lang="stylus">
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
  margin-top 60px
</style>
